const getters = {
  languages: ({ languages }) => languages,

  languagesSimple: ({ languages }) => Object.keys(languages).map(key => {
    return {
      label: languages[key].code,
      value: languages[key].id
    }
  }),

  getById: ({ languages }) => (id) => {
    return languages[id]
  },

  active: ({ active }) => active
}

export default getters
